import { set, unset } from "../../js/lib/util";
import { createApp, defineComponent } from "vue";

export default (el: HTMLElement) => {
  const componentDefinition = defineComponent({
    data() {
      return {
        product: (window as any).BARREL.product,
        activeAccordion: null as string | null,
        reviews: "",
        shopDomain: (window as any).BARREL.shop,
      };
    },
    methods: {
      toggleAccordion(reference: string, scrollTo = true) {
        if (this.activeAccordion === reference) {
          this.activeAccordion = null;
        } else {
          this.activeAccordion = reference;
        }

        if (scrollTo) {
          setTimeout(() => {
            // scroll reference into view
            const accordion = document.querySelector(
              `div[aria-labelledby="${reference}"]`
            ) as HTMLElement;

            if (accordion) {
              accordion.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "start",
              });
            }
          }, 100);
        }
      },
      height(reference: string) {
        if (this.activeAccordion !== reference) {
          return 0;
        }

        return (
          (this.$refs[reference] as HTMLElement).getBoundingClientRect()
            .height + "px"
        );
      },
      showModal(modal: string) {
        set(document.body, "showing-modal");
        set(
          document.querySelector(
            `.js-modal[data-modal=${modal}]`
          ) as HTMLElement,
          "active"
        );
      },
      hideModal(modal: string) {
        unset(document.body, "showing-modal");
        unset(
          document.querySelector(
            `.js-modal[data-modal=${modal}]`
          ) as HTMLElement,
          "active"
        );
      },
    },
    mounted() {
      if (document.querySelector(".accordion-description")) {
        this.toggleAccordion("accordion-description", false);
      } else {
        this.toggleAccordion("accordion-1", false);
      }

      setTimeout(() => {
        let writeReviewLink = document.querySelector(
          ".spr-summary-actions-newreview"
        ) as HTMLElement;
        let writeReviewModal = document.querySelector(
          ".spr-form"
        ) as HTMLElement;
        let writeReviewWindow = document.querySelector(
          ".new-review-form"
        ) as HTMLElement;
        const span = document.createElement("button");
        span.className = "close-review-button js-close-review";
        span.type = "button";

        writeReviewLink &&
          writeReviewLink.addEventListener("click", () => {
            set(document.body, "showing-modal");
            writeReviewWindow.appendChild(span);
            span.style.top = `${writeReviewWindow.offsetTop + 10}px`;

            const modalInput = document.querySelector(
              ".spr-form-contact-name input"
            ) as HTMLInputElement;

            if (modalInput) {
              modalInput.focus();
            }
          });

        writeReviewModal &&
          writeReviewModal.addEventListener("click", (e) => {
            if (!(e.target as HTMLElement).closest(".js-close-review")) {
              return;
            }

            writeReviewWindow.appendChild(span);
            unset(document.body, "showing-modal");
            writeReviewModal.style.display = "none";
          });

        document.addEventListener("keyup", function (e) {
          if (e.keyCode === 27) {
            unset(document.body, "showing-modal");
            writeReviewModal.style.display = "none";
          }
        });

        document.addEventListener("spr:form:failure", function () {
          setTimeout(() => {
            writeReviewWindow = document.querySelector(
              ".new-review-form"
            ) as HTMLElement;
            writeReviewWindow.appendChild(span);
          }, 200);
        });

        document.addEventListener("spr:form:loaded", function () {
          writeReviewWindow.appendChild(span);

          // move the the spr-form element to the body
          document.body.appendChild(writeReviewModal);

          // once it's loaded then we need to remove the fixed height if we have one
          const closest = writeReviewWindow.closest(
            ".product-accordion__body"
          ) as HTMLElement;

          if (closest) {
            closest.style.maxHeight = "0";
          }
        });

        document.addEventListener("spr:form:success", function () {
          setTimeout(() => {
            writeReviewWindow = document.querySelector(
              ".new-review-form"
            ) as HTMLElement;
            writeReviewWindow.appendChild(span);
            var button = document.createElement("button");
            button.setAttribute("type", "button");
            button.className = "close-review-button";
            button.addEventListener("click", function () {
              const sprForm = document.querySelector(
                ".spr-form"
              ) as HTMLElement;
              if (sprForm) {
                sprForm.style.display = "none";
              }
            });
            writeReviewWindow.appendChild(button);
          }, 200);
        });
      }, 3000);
    },
  });

  const instanceApp = createApp(componentDefinition as any);
  return instanceApp.mount(el);
};
